import React, { useEffect, useState, useRef } from "react";
// import ReactApexChart from "react-apexcharts";
import { Nav, Tab } from "react-bootstrap";
import { POST_GetTodaysSummaryData } from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import * as echarts from "echarts";

// const chartHeaderData = [
//   { title: "Week", type: "week" },
//   { title: "Month", type: "month" },
//   { title: "Year", type: "year" },
//   { title: "All", type: "all" },
// ];

const TestingOverviewChart = () => {
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [isLoading, setIsLoading] = useState(false);
  const [testingMonthWiseData, setTestingMonthWiseData] = useState([]);
  const [todaysInwardCount, setTodaysInwardCount] = useState(0);
  const [
    todaysInwardApprovalPendingCount,
    setTodaysInwardApprovalPendingCount,
  ] = useState(0);
  const [
    todaysTestingApprovalPendingCount,
    setTodaysTestingApprovalPendingCount,
  ] = useState(0);

  const [todaysReportDispatchCount, setTodaysReportDispatchCount] = useState(0);
  const [todaysTestingCount, setTodaysTestingCount] = useState(0);

  const [monthShortNameChart, setMonthShortName] = useState([]);
  const [testingCountChart, setTestingCount] = useState([]);

  useEffect(() => {
    getDashboardDetails();
  }, []);

  const getDashboardDetails = async () => {
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };

    await post(POST_GetTodaysSummaryData, payload)
      .then((response) => {
        setTodaysInwardCount(response?.TodaysInwardCount);
        setTodaysInwardApprovalPendingCount(
          response?.TodaysInwardApprovalPendingCount
        );
        setTodaysTestingApprovalPendingCount(
          response?.TodaysTestingApprovalPendingCount
        );
        setTodaysReportDispatchCount(response?.TodaysReportDispatchCount);
        setTodaysTestingCount(response?.TodaysTestingCount);
        setTestingMonthWiseData(response?.TestingMonthWiseData);

        bindChartData(response?.TestingMonthWiseData);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const bindChartData = (list) => {
    let monthShortNameArray = [],
      testingCountArray = [];

    Promise.all(
      list?.map((x) => {
        monthShortNameArray.push(x.MonthShortName);
        testingCountArray.push(x.TestingCount);
      })
    );
    setMonthShortName(monthShortNameArray);
    setTestingCount(testingCountArray);
  };

  const chartRef = useRef();

  useEffect(() => {
    //getDashboardDetails();
    const myChart = echarts.init(chartRef.current);

    const options = {
      xAxis: {
        type: "category",
        data: monthShortNameChart,
      },
      yAxis: {
        type: "value",
      },
      tooltip: {
        // trigger: "axis", // Show tooltip when hovering over any axis item
        formatter: "{b}: {c}", // Customize tooltip format
      },
      series: [
        {
          data: testingCountChart,
          type: "bar",
        },
      ],
      grid: {
        left: 35,
        top: 30,
        right: "5%",
        bottom: "8%",
      },
    };

    myChart.setOption(options);

    // Clean up the chart instance
    return () => {
      myChart.dispose();
    };
  }, [testingMonthWiseData]);

  return (
    <>
      <div className="card mb-2" style={{ height: "calc(100% - 10px)" }}>
        <div className="card-header p-3 pb-0 border-0 flex-wrap">
          <h4 className="heading mb-0">Testing</h4>
        </div>
        <div className="card-body p-0">
          <div id="overiewChart">
            <div
              ref={chartRef}
              style={{
                width: "100%",
                height: "360px",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TestingOverviewChart;
